import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogConfig,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { EDialogWidth } from '../../../core/constants/ui.constants';

export interface IEndpointResponsePreviewDialogData {
  title: string;
  json: string;
}

@Component({
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton, TranslatePipe],
  selector: 'app-endpoint-response-preview-dialog',
  styleUrl: './endpoint-response-preview-dialog.component.scss',
  templateUrl: './endpoint-response-preview-dialog.component.html',
})
export class EndpointResponsePreviewDialogComponent {
  public static dialogConfig: MatDialogConfig = {
    closeOnNavigation: true,
    maxWidth: '100%',
    restoreFocus: false,
    width: EDialogWidth.medium,
  };

  public readonly data = inject<IEndpointResponsePreviewDialogData>(MAT_DIALOG_DATA);
}
